module.exports = __webpack_public_path__ + "static/media/4.c2f9fc52.png";